<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <div class="block">
        <!-- <yz-daterange @dateRange="getChooseTime"></yz-daterange> -->
        <el-date-picker v-model="value" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :editable="false" @change="chooseTime">
        </el-date-picker>
        <el-input v-model.trim="inputVal" class="input_s200" placeholder="请输入姓名/手机号码" @keyup.enter.native="search">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
        </el-input>
        <el-button class="ml_20" type="primary" @click="exportList">导出Excel</el-button>
      </div>
      <div class="commonInfo">
        <div class="content">
          <h3>时间：{{ value?value[0]:'' }}~{{ value?value[1]:'' }}</h3>
          <h3>收入总额：{{ sumTotal ? sumTotal.toFixed(2) : '0.00' }}元</h3>
        </div>
      </div>
      <div class="commonTable">
        <el-table :data="tableData" tooltip-effect="light">
          <el-table-column prop="payTime" :show-overflow-tooltip="true" label="时间">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.memberName == '散客' ? '新增顾客' : scope.row.memberName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" :show-overflow-tooltip="true" label="手机号码">
            <template slot-scope="scope">
              <span>{{ scope.row.phone || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cardNo" :show-overflow-tooltip="true" label="会员卡号">
            <template slot-scope="scope">
              <span>{{ scope.row.cardNo || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="itemName" :show-overflow-tooltip="true" label="服务项目">
            <template slot-scope="scope">
              <span v-if="scope.row.itemName">{{ scope.row.itemName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="productName" :show-overflow-tooltip="true" label="产品销售">
            <template slot-scope="scope">
              <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="total" :show-overflow-tooltip="true" label="消费金额（元）">
          </el-table-column>
          <el-table-column prop="dutyName" :show-overflow-tooltip="true" label="操作人">
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <yz-btn type="primary" @click="lookOrder(scope.row)">详情</yz-btn>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="tableData.length > 0" class="blockThree">
        <el-pagination background :current-page.sync="currentPage" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <gt-footer></gt-footer>
    <el-dialog :title="'订单号：'+orderCode" :visible.sync="orderDeatilsDialog" :append-to-body="true" width="1000px">
      <yz-order-deatils :order-deatils-data="orderDeatilsData" :loading="loading2" @tansferDialog="getDialogData"></yz-order-deatils>
    </el-dialog>
    <!-- <gt-details @tansferPhone="getDetailsData"></gt-details> -->
  </div>
</template>

<script>
import { getFwkd, getOrderDetails } from '../../api';
import YzOrderDeatils from '../../../stage/template/orderDetails/index';

export default {
  components: {
    YzOrderDeatils
  },
  data() {
    return {
      value: '', // 时间段
      pickerOptions: { // 只能查询请今天之前的时间
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      inputVal: '', // 搜索值
      currentPage: 1,
      tableData: [], // 服务开单记录
      pageNum: 1,
      rowCount: '',
      sumTotal: '', // 收入总额
      detailsData: { // 服务开单详情--赋值
        memberId: '',
        urlStatus: '',
        detailsDialog: false
      },
      orderDeatilsDialog: false,
      orderCode: '',
      orderDeatilsData: {
        itemList: [],
        payTypeList: []
      },
      // 5.7
      loading: true,
      loading2: true,
    };
  },
  activated() {
    this.value = this.Lib.G(7, 'yyyy-MM-dd');
    this.getListData();
  },
  methods: {
    // 得到子组件选择的时间
    getChooseTime(time) {
      this.value = time;
      this.chooseTime(time);
    },
    // 选择时间段
    chooseTime() {
      this.Lib.keyboardBlur();
      this.pageNum = 1;
      this.currentPage = 1;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.Lib.keyboardBlur();
      this.pageNum = 1;
      this.currentPage = 1;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 导出订单列表
    exportList() {
      const vm = this;
      if (vm.value) {
        window.location.href = `${this.Lib.A()
        }/erp/statistics/exportProductSale?startDate=${
          vm.value[0]
        }&endDate=${
          vm.value[1]
        }&keyWord=${
          vm.inputVal}`;
      } else {
        window.location.href = `${this.Lib.A()
        }/erp/statistics/exportProductSale?keyWord=${
          vm.inputVal}`;
      }
    },
    // 订单列表
    getListData() {
      const vm = this;
      const data = {
        startDate: '',
        endDate: '',
        keyWord: vm.inputVal,
        pageNum: vm.pageNum
      };
      if (vm.value) {
        data.startDate = vm.value[0];
        data.endDate = vm.value[1];
      }
      getFwkd(data).then((res) => {
        vm.tableData = res.data.page.subList;
        vm.sumTotal = res.data.sumTotal;
        vm.rowCount = res.data.page.rowCount;
      });
    },
    // 赋值组件数据
    getDetailsData(list) {
      this.detailsData = list;
    },
    // 赋值组件数据
    getDialogData(list) {
      this.orderDeatilsDialog = list;
    },
    // 查看订单
    lookOrder(row) {
      this.loading2 = true;
      this.orderDeatilsDialog = true;
      getOrderDetails({ id: row.id }).then((res) => {
        if (res.code === 0) {
          const arr = [];
          res.data.serveItemsList ? res.data.serveItemsList : res.data.serveItemsList = [];
          res.data.productSalesList ? res.data.productSalesList : res.data.productSalesList = [];
          res.data.vipCardList ? res.data.vipCardList : res.data.vipCardList = [];
          res.data.memberMsg ? res.data.memberMsg = res.data.memberMsg : res.data.memberMsg = {};
          res.data.serveItemsList.forEach((a) => {
            a.listStatus = 1;
            arr.push(a);
          });
          res.data.productSalesList.forEach((b) => {
            b.listStatus = 2;
            b.resultPrice = b.total;
            arr.push(b);
          });
          res.data.vipCardList.forEach((c) => {
            c.listStatus = 3;
            arr.push(c);
          });
          res.data.consumptionList = arr;
          res.data.newStatus = 2;
          this.orderDeatilsData = res.data;
          this.orderCode = res.data.orderCode;
          this.loading2 = false;
        }
      });
    },
    projectEdit(id) {
      this.detailsData.memberId = id;
      this.detailsData.urlStatus = '1';
      this.detailsData.detailsDialog = true;
    }
  }
};
</script>
